import { Navigate } from "react-router-dom";
import { useEffect, useState, ReactNode } from "react";
import { supabase } from "../supabaseClient";

export const PrivateRoute = ({ children }: { children: ReactNode }) => {
  const [loading, setLoading] = useState(true);
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (mounted) {
        setIsAuth(!!user);
        setLoading(false);
      }
    })();

    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setIsAuth(!!session?.user);
      setLoading(false);
    });
    return () => {
      mounted = false;
      sub.subscription?.unsubscribe();
    };
  }, []);

  if (loading) return <div className="text-center mt-10">Chargement…</div>;
  return isAuth ? <>{children}</> : <Navigate to="/login" replace />;
};
